import "./ExpertiseSection.css";

const expertiseData = [
  { title: "Artificial Intelligence", image: "/images/ai.jpg" },
  { title: "Data Science", image: "/images/ds.jpg" },
  { title: "Machine Learning", image: "/images/ml.png" },
  { title: "Internet of Things", image: "/images/iot.jpg" },
  { title: "AR and VR", image: "/images/ar_vr.jpg" },
  { title: "Data Structures & Algorithms", image: "/images/dsa.jpg" },
  { title: "Programming Languages", image: "/images/prog.webp" },
];

export default function ExpertiseSection() {
  return (
    <section className="expertiseX-section">
      <div className="expertiseX-container">
        <h2 className="expertiseX-title">We Are Expertise In</h2>

        {/* Infinite scroll wrapper */}
        <div className="expertiseX-scroll-wrapper">
          <div className="expertiseX-scroll-container">
            {expertiseData.concat(expertiseData).map((item, index) => (
              <div key={index} className="expertiseX-card">
                <img
                  src={item.image}
                  alt={item.title}
                  className="expertiseX-image"
                />
                <div className="expertiseX-content">
                  <h3 className="expertiseX-card-title">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
